import { hash } from '@ember/helper';
import { service } from '@ember/service';

import Component from 'umg-ember-backend/components/record-detail/forms';
import AssetPreview from 'umg-ember-backend/components/ui/asset-preview/index';
import Form from 'umg-ember-backend/components/ui/form';

export default class RecordDetailFormsLivePartnerComponent extends Component {
  // Services
  @service data;

  // Defaults
  countryOptions = [];
  partnerTypeOptions = [];

  // Hooks
  constructor() {
    super(...arguments);

    this.countryOptions = this.data.getCategories({
      'filter[type]': 'COUNTRY',
    });
    this.partnerTypeOptions = this.data.getCategories({
      'filter[type]': 'P_TYPE_LIVE',
    });
  }

  // Template
  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <div class='o-layout'>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='general' as |fieldset|>
            <fieldset.field @property='name' />
            <fieldset.field @property='city' />
            <fieldset.field @property='cityEn' />
            <fieldset.field @property='street' />
            <fieldset.field @property='zipcode' />

            <fieldset.field
              @property='country'
              @type='select-record'
              @isSearchEnabled={{true}}
              @options={{this.countryOptions}}
            />
          </form.fieldset>
        </div>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='configuration' as |fieldset|>
            <fieldset.field
              @filters={{hash assetFolderId='8'}}
              @property='logo'
              @on={{hash openNewRecord=false openRecord=false}}
              @options={{hash allowedFolder='100'}}
              @type='belongs-to'
              as |record|
            >
              <AssetPreview @asset={{record}} />
            </fieldset.field>

            <fieldset.field
              @property='link'
              @type='belongs-to'
              @on={{hash openNewRecord=false openRecord=false}}
            />

            <fieldset.field
              @property='partnerType'
              @type='select-record'
              @options={{this.partnerTypeOptions}}
            />

            <fieldset.field @property='dgg' @type='checkbox' />
          </form.fieldset>

          <form.sections.meta />
        </div>
      </div>
    </Form>
  </template>
}
